import classNames from "clsx";

export type DropdownMenuSeparatorProps = {
  "data-testid"?: string;
  className?: string;
};

export const DropdownMenuSeparator = ({
  className: additionalClasses,
  "data-testid": dataTestId,
}: DropdownMenuSeparatorProps) => {
  return (
    <div
      data-testid={dataTestId ?? "dropdown-menu-separator"}
      className={classNames("h-px", "bg-border-base-divider", "w-auto", "my-2", additionalClasses)}
    />
  );
};
